'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotScattermapboxIcon = function PlotScattermapboxIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M23.75 19.438a.791.791 0 0 0-1.125 0l-1 1.063-1.313-1.313 2.625-2.625a.791.791 0 0 0 0-1.125l-2.625-2.625 1.313-1.313c1 .688 2.125 1.063 3.313 1.063.938 0 1.813-.188 2.625-.688.25-.125.375-.313.438-.563 0-.25-.063-.5-.25-.688l-2.625-2.625 1.063-1.063c.313-.313.313-.813 0-1.125s-.813-.313-1.125 0l-1.063 1.063-2.625-2.625c-.188-.188-.438-.25-.688-.25-.25.063-.438.188-.563.438-1.063 1.875-.875 4.188.375 5.938l-1.313 1.313-2.625-2.625a.791.791 0 0 0-1.125 0l-2.625 2.625-1.25-1.313 1-1a.791.791 0 0 0 0-1.125L6.187 1.812a.791.791 0 0 0-1.125 0l-3.25 3.25a.791.791 0 0 0 0 1.125l6.438 6.375c.125.188.375.25.563.25s.375-.063.563-.25l1-1 1.313 1.25-2.625 2.625a.791.791 0 0 0 0 1.125l2.625 2.625-1.313 1.313c-1.75-1.25-4.063-1.438-5.938-.375-.25.125-.375.313-.438.563 0 .25.063.5.25.688l2.625 2.625-1.063 1.063a.791.791 0 0 0 0 1.125c.188.125.375.188.563.188.25 0 .438-.063.563-.188l1.063-1.063 2.625 2.625c.188.188.375.25.563.25h.125c.25-.063.438-.188.563-.438 1.063-1.875.875-4.188-.375-5.938l1.313-1.313 2.625 2.625c.125.188.375.25.563.25s.438-.063.563-.25l2.625-2.625 1.313 1.313-1.063 1a.791.791 0 0 0 0 1.125l6.375 6.438c.188.125.375.188.563.188.25 0 .438-.063.563-.188l3.25-3.25a.791.791 0 0 0 0-1.125zM21.125 6.25l4.625 4.625a3.672 3.672 0 0 1-3.563-1.063 3.674 3.674 0 0 1-1.063-3.563zM3.563 5.625l2.063-2.063 2.063 2.063-2.063 2.063zm5.25 5.25L6.75 8.812l2.063-2.063 2.063 2.063zm2.062 14.875L6.25 21.125a3.672 3.672 0 0 1 3.563 1.063 3.674 3.674 0 0 1 1.063 3.563zM16 21.25L10.75 16 16 10.75 21.25 16zm5.125 1.938l2.063-2.063 2.063 2.063-2.063 2.063zm5.25 5.25l-2.063-2.063 2.063-2.063 2.125 2.063z' })
    );
};

exports.default = PlotScattermapboxIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotScattermapboxIcon.js
// module id = 685
// module chunks = 0